export const isChildGridRow = (row, rowId, flatChildView = false) => {
  if (flatChildView) return false;
  const id = String(rowId);
  if (row?.isChildRow) return true;
  if (id.includes("__child__") || id.startsWith("child::")) return true;
  if (row?.distributionType === "C" && row?.parentTradeId != null) return true;
  return false;
};

export const isNonSelectableChildRow = (row, rowId) => {
  if (row?.isChildRow) return true;
  const id = String(rowId);
  if (id.includes("__child__") || id.startsWith("child::")) return true;
  if (row?.distributionType === "C" && row?.parentTradeId != null) return true;
  return false;
};

export const buildTopLevelDisplayNumberMap = (rowIds, getRow, flatChildView = false) => {
  const map = new Map();
  let count = 0;
  rowIds.forEach((id) => {
    const normalizedId = String(id);
    const row = getRow(id);
    if (isChildGridRow(row, normalizedId, flatChildView)) return;
    count += 1;
    map.set(normalizedId, count);
  });
  return map;
};

export const getStateColor = (state) => {
  switch (state?.toLowerCase()) {
    case "working":
      return "info";
    case "ready":
      return "success";
    case "pending":
      return "warning";
    default:
      return "default";
  }
};

export const getOptionLabel = (optionEnum) => {
  if (optionEnum === 0 || optionEnum === "0") return "Calls";
  if (optionEnum === 1 || optionEnum === "1") return "Puts";
  return "";
};

export const formatExpirationDate = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
};
